import { RemoveFolderSharingsRequest, RemoveFolderSharingsResponse } from "./FolderSharing.dto";
import { FolderSharingUrl } from "./FolderSharing.url";
import { ApiReq } from "../common/flax.types";
import { extractKey, HttpRequest } from "../common/HttpRequest";

export class FolderSharingRest {
  public static async removeFolderSharing(req: ApiReq<RemoveFolderSharingsRequest>): Promise<RemoveFolderSharingsResponse> {
    const sharingId = extractKey(req, "sharingId");
    const authorization = extractKey(req, "authorization");

    const resp = await HttpRequest.request<RemoveFolderSharingsResponse>(
      process.env.REACT_APP_DOCS_BE_URL,
      ...FolderSharingUrl.removeFolderSharings(sharingId),
      req,
      { authorization }
    );

    return resp.data;
  }
}
